import headers from './headers';
import axios from 'axios';

async function getSaasList() {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/list`, { headers });
}

async function getUsersCount(saasId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/users/count`, { headers });
}

async function getClientsCount(saasId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/clients/count`, { headers });
}

async function getSalesCount(saasId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/sales/count`, { headers });
}

async function getOffersStats(saasId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/offers/stats`, { headers });
}

async function getClientsList(saasId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/clients/list`, { headers });
}

async function getSalesList(saasId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/sales/list`, { headers });
}

async function getUsersList(saasId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/users/list`, { headers });
}

async function getUserStats(saasId, b2cId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/users/${b2cId}/stats`, { headers });
}

async function getUserRegistrations(saasId, params = {}) {
  const queryString = new URLSearchParams(params).toString();
  const url = `${process.env.VUE_APP_API_URL}saas/${saasId}/users/registrations${queryString ? '?' + queryString : ''}`;
  return await axios.get(url, { headers });
}

async function getLevelsOffers(saasId) {
  return await axios.get(`${process.env.VUE_APP_API_URL}saas/${saasId}/levels/offers`, { headers });
}

export default {
  getSaasList: () => getSaasList(),
  getUsersCount: (saasId) => getUsersCount(saasId),
  getClientsCount: (saasId) => getClientsCount(saasId),
  getSalesCount: (saasId) => getSalesCount(saasId),
  getOffersStats: (saasId) => getOffersStats(saasId),
  getClientsList: (saasId) => getClientsList(saasId),
  getSalesList: (saasId) => getSalesList(saasId),
  getUsersList: (saasId) => getUsersList(saasId),
  getUserStats: (saasId, b2cId) => getUserStats(saasId, b2cId),
  getUserRegistrations: (saasId, params) => getUserRegistrations(saasId, params),
  getLevelsOffers: (saasId) => getLevelsOffers(saasId),
};

